import { intersection } from 'lodash';

/**
 * Returns true if the tags filter matches
 * @param {object} tags         Tags filter
 * @param {object} directoryItem    Exhibitor object
 * @return boolean
 */
export function isDirectoryMatchForTags(tags, directoryItem) {
    // exhibitors without tags set match the filter
    if (!'tags' in directoryItem) return true;

    // empty filter
    if (!Object.values(tags).find((options) => options.length)) return true;

    for (let tagName in tags) {
        // empty category: ignore
        if (!tags[tagName].length) {
            continue;
        }

        const itemTags = directoryItem.tags.find((tag) => tag.name == tagName) ?? [];

        // Some tags on the category: check if any matches
        const matchedTags = intersection(itemTags.options, tags[tagName]);
        if (!matchedTags.length) {
            return false;
        }
    }

    return true;
}
